import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    AssemblyContainersPayload,
    AssignCointainersToCourierPayload,
    AttachInvoicesToContainerPayload,
    ContainerPayload,
    GenerateContainerPayload,
    GetContainersParams,
    GetContainersResponse,
    GetPlanningRecordsParams,
    GetPlanningRecordsResponse,
    GetPlanningCouriersResponse,
    GetPlanningCouriersParams,
    GetHoldRecordsParams,
    GetHoldRecordsResponse,
    PickupCodeResponse,
} from '@/new-services/types/planning'

type ApiGetPlanningRecordsResponse = Promise<AxiosResponse<GetPlanningRecordsResponse>>
type ApiCreateContainerResponse = Promise<AxiosResponse<void>>
type ApiGenerateContainerResponse = Promise<AxiosResponse<void>>
type ApiAttachInvoicesToContainerResponse = Promise<AxiosResponse<void>>
type ApiGetContainersResponse = Promise<AxiosResponse<GetContainersResponse>>
type ApiAssignContainersToCourierResponse = Promise<AxiosResponse<void>>
type ApiAssemblyContainersResponse = Promise<AxiosResponse<void>>
type ApiGetPlanningCouriersResponse = Promise<AxiosResponse<GetPlanningCouriersResponse>>
type ApiGetHoldRecordsResponse = Promise<AxiosResponse<GetHoldRecordsResponse>>
type ApiPickupCodeResponse = Promise<AxiosResponse<PickupCodeResponse>>

export function getPlanningRecords(
    params: GetPlanningRecordsParams
): ApiGetPlanningRecordsResponse {
    return http.get('/dispatcher/api/planning', { params })
}

export function getHoldRecords(params: GetHoldRecordsParams): ApiGetHoldRecordsResponse {
    return http.get('/dispatcher/api/invoices/on-hold', { params })
}

export function getContainers(params: GetContainersParams): ApiGetContainersResponse {
    return http.get('/dispatcher/api/containers', { params })
}

export function createContainer(payload: ContainerPayload): ApiCreateContainerResponse {
    return http.post('/dispatcher/api/containers', payload)
}

export function generateContainer(payload: GenerateContainerPayload): ApiGenerateContainerResponse {
    return http.post('/dispatcher/api/containers/generate', payload)
}

export function attachInvoicesToContainer(
    container_id: number,
    payload: AttachInvoicesToContainerPayload
): ApiAttachInvoicesToContainerResponse {
    return http.post(`/dispatcher/api/containers/${container_id}/attach-invoices`, payload)
}

export function deleteInvoiceFromContainer(
    containerId: number,
    invoiceIds: number[]
): ApiAttachInvoicesToContainerResponse {
    return http.post('/dispatcher/api/container-invoices/detach', { containerId, invoiceIds })
}

export function deleteContainer(containerId: number): ApiAttachInvoicesToContainerResponse {
    return http.delete(`/dispatcher/api/containers/${containerId}`)
}

export function assignContainersToCourier(
    payload: AssignCointainersToCourierPayload
): ApiAssignContainersToCourierResponse {
    return http.post('/dispatcher/api/containers/assign-courier', payload)
}

export function assemblyContainers(
    payload: AssemblyContainersPayload
): ApiAssemblyContainersResponse {
    return http.post('/dispatcher/api/containers/send-assembly', payload)
}

export function getPlanningCouriers(
    params: GetPlanningCouriersParams
): ApiGetPlanningCouriersResponse {
    return http.get('/dispatcher/api/planning/couriers', { params })
}

export function pickupCode(id: number): ApiPickupCodeResponse {
    return http.get(`/delivery/api/orders/${id}/pickup-code`)
}

export default {
    getPlanningRecords,
    getContainers,
    createContainer,
    generateContainer,
    attachInvoicesToContainer,
    assignContainersToCourier,
    assemblyContainers,
    getPlanningCouriers,
    deleteInvoiceFromContainer,
    deleteContainer,
    getHoldRecords,
    pickupCode,
}
